/**
 * Summernote custom button: Alt Text
 *
 * Allows editing image ALT text and synchronizes it with a wrapper (`.img-wrap`)
 * used for visual ALT rendering via CSS pseudo-elements.
 *
 * Compatible with Vue 2 + VueSummernote
 */
export const AltTextButton = function (context) {
    const ui = $.summernote.ui;

    /**
     * Returns currently selected image inside the editor
     */
    const getTargetImage = () => {
        return $(context.layoutInfo.editable.data('target'));
    };

    /**
     * Extracts specific CSS property from inline style string
     */
    const extractStyle = (style, property) => {
        const match = style.match(new RegExp(`${property}:\\s*([^;]+)`));
        return match ? match[1] : null;
    };

    /**
     * Ensures that the image is wrapped with `.img-wrap`
     * Copies required classes and styles to the wrapper
     */
    const ensureWrapper = ($image) => {
        let $wrapper = $image.parent('.img-wrap');

        if ($wrapper.length) return $wrapper;

        // Wrap image
        $image.wrap('<div class="img-wrap"></div>');
        $wrapper = $image.parent('.img-wrap');

        // Copy classes (except Summernote selection class)
        const imageClasses = ($image.attr('class') || '')
            .replace('note-selected', '')
            .trim();

        if (imageClasses) {
            $wrapper.addClass(imageClasses);
        }

        // Copy width and float styles to wrapper
        const imageStyle = $image.attr('style') || '';
        const width = extractStyle(imageStyle, 'width');
        const float = extractStyle(imageStyle, 'float');

        const wrapperStyle = [
            width && `width:${width}`,
            float && `float:${float}`
        ].filter(Boolean).join(';');

        if (wrapperStyle) {
            $wrapper.attr('style', wrapperStyle);
        }

        return $wrapper;
    };

    const button = ui.button({
        contents: '<span>Alt Text</span>',
        tooltip: 'Edit image alt text',
        click: function () {
            const $image = getTargetImage();
            if (!$image.length) return;

            const currentAlt = $image.attr('alt') || '';
            const newAltText = prompt('Enter alt text for image:', currentAlt);

            // User cancelled
            if (newAltText === null) return;

            // Update image ALT attribute
            $image.attr('alt', newAltText);

            // Ensure wrapper exists and sync ALT
            const $wrapper = ensureWrapper($image);
            $wrapper.attr('data-alt', newAltText);

            // Notify Vue / Summernote about content change
            $(context.layoutInfo.editable).trigger('input');
        }
    });

    return button.render();
};
